import { zodResolver } from '@hookform/resolvers/zod'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { useFormField } from '~/hooks/useFormField'

import { createFileInfoSchema, questionDataTypes } from '../utils'

import { QuestionDataTypeSwitcher } from './QuestionDataTypeSwitcher'
import { UploadFileSection } from './UploadFileSection'

// NOTE: typeのためにi18nが複雑化するためanyで回避
// eslint-disable-next-line
export const UploadQuestionFileSection = ({ onSubmit }: any) => {
  const { t } = useTranslation()
  const schema = createFileInfoSchema(t).extend({
    dataType: z.enum(questionDataTypes),
  })
  type InputValues = z.infer<typeof schema>
  const resolver = zodResolver(schema)
  const { control, handleSubmit } = useForm<InputValues>({
    defaultValues: { dataType: 'macromill' },
    resolver,
  })
  const dataTypeField = useFormField(control, 'dataType')

  return (
    <UploadFileSection
      control={control}
      extraFormLabel={t('format')}
      onUpload={handleSubmit(onSubmit)}
    >
      <QuestionDataTypeSwitcher
        value={dataTypeField.value}
        onChange={dataTypeField.onChange}
      />
    </UploadFileSection>
  )
}
